import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, Button } from "@material-ui/core";
import {
  OutlinedInput,
  ListItemText,
  TextField,
  Select,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { useSelector } from "react-redux";
import * as env from "../utils/EnvVars";
import TopicName from "../components/TopicName";
import KeywordName from "../components/KeywordName";
import GradeName from "../components/GradeName";
import DifficultyName from "../components/DifficultyName";
import ExamType from "../components/ExamType";
import Country from "../components/Country";
import Tags from "../components/Tags";
import Language from "../components/Language";
import Radio from "@mui/material/Radio";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical = "top",
  horizontal = "center";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const userObj = useSelector((state) => state.userDetails);
  const [open, setOpen] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [saveLoading, setSaveLoading] = React.useState(false);

  const alphaArr = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const alphaNumArr = [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
    "XIII",
    "XIV",
    "XV",
  ];

  const [rows, setRows] = React.useState([]);
  const [ansOptionRows, setAnsOptionRows] = React.useState([]);

  const [questionTypeId, setQuestionTypeId] = React.useState(7);

  const [templateTitle, setTemplateTitle] = React.useState("");
  const [treeviewTemplateId, setTreeviewTemplateId] = React.useState(0);
  const [treeviewTemplateTitle, setTreeviewTemplateTitle] = React.useState("");
  const [selftestOptionsObjectiveId, setSelftestOptionsObjectiveId] =
    React.useState(0);
  const [selftestOptionsObjectiveTitle, setSelftestOptionsObjectiveTitle] =
    React.useState("");
  const [selftestOptionsSubjectiveId, setSelftestOptionsSubjectiveId] =
    React.useState(0);
  const [selftestOptionsSubjectiveTitle, setSelftestOptionsSubjectiveTitle] =
    React.useState("");
  const [examLimitId, setExamLimitId] = React.useState(0);
  const [examLimitTitle, setExamLimitTitle] = React.useState("");
  const [objectiveQueTypeTempId, setObjectiveQueTypeTempId] = React.useState(0);
  const [objectiveQueTypeTempTitle, setObjectiveQueTypeTempTitle] =
    React.useState("");
  const [subjectiveQueTypeTempId, setSubjectiveQueTypeTempId] =
    React.useState(0);
  const [subjectiveQueTypeTempTitle, setSubjectiveQueTypeTempTitle] =
    React.useState("");
  const [mocktestTemplateId, setMocktestTemplateId] = React.useState(0);
  const [mocktestTemplateTitle, setMocktestTemplateTitle] = React.useState("");
  const [topictestTemplateId, setTopictestTemplateId] = React.useState(0);
  const [topictestTemplateTitle, setTopictestTemplateTitle] =
    React.useState("");

  const [treeviewTemplateList, setTreeviewTemplateList] = React.useState([]);
  const [selftestOptionsObjectiveList, setSelftestOptionsObjectiveList] =
    React.useState([]);
  const [selftestOptionsSubjectiveList, setSelftestOptionsSubjectiveList] =
    React.useState([]);
  const [examLimitList, setExamLimitList] = React.useState([]);
  const [objectiveQueTypeTempList, setObjectiveQueTypeTempList] =
    React.useState([]);
  const [subjectiveQueTypeTempList, setSubjectiveQueTypeTempList] =
    React.useState([]);
  const [mocktestTemplateList, setMocktestTemplateList] = React.useState([]);
  const [topictestTemplateList, setTopictestTemplateList] = React.useState([]);
  const [questionBody, setQuestionBody] = useState("");
  const [leftHeader, setLeftHeader] = useState("");
  const [rightHeader, setRightHeader] = useState("");
  const [explanation, setExplanation] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [questionTypeName, setQuestionTypeName] = useState("MC Matching Type");

  const [topicList, setTopicList] = useState([]);
  const [topicId, setTopicId] = useState(0);
  const [topicName, setTopicName] = useState("");
  const [examType, setExamType] = useState("");
  const [gradeList, setGradeList] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeId, setGradeId] = useState(0);
  const [difficultyList, setDifficultyList] = useState([]);
  const [difficultyName, setDifficultyName] = useState("");
  const [difficultyId, setDifficultyId] = useState(0);
  const [languageList, setLanguageList] = useState([]);
  const [languageName, setLanguageName] = useState("");
  const [languageId, setLanguageId] = useState(0);
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState("");
  const [countryId, setCountryId] = useState(0);
  const [tags, setTags] = useState([]);
  const [keyword, setKeyword] = useState([]);
  const [formattedKeyword, setFormattedKeyword] = useState("");
  const [formattedTags, setFormattedTags] = useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert() {
    setShowAlert(false);
  }

  React.useEffect(() => {
    setRows([]);
    // if (open && userObj) {
    //   createOption(7);
    // }
    if (open) {
      createOption(7);
      getData();
    }

    if (open && props.dataObj && props.dataObj.autoId) {
      setQuestionTypeId(props.dataObj.questionTypeId);
      setQuestionBody(props.dataObj.questionBankSet.questionBody);
      setQuestionTypeName(props.dataObj.questionBankSet.questionType);
      setGradeId(props.dataObj.gradeId);
      setGradeName(props.dataObj.gradeName);
      setTopicId(props.dataObj.topicId);
      setTopicName(props.dataObj.topicName);
      setDifficultyId(props.dataObj.difficultyId);
      setDifficultyName(props.dataObj.difficultyName);
      setExamType(props.dataObj.examType);
      setLanguageName(props.dataObj.language);
      setCountryName(props.dataObj.country);
      const TagsArray = props.dataObj.tags
        .split(",")
        .filter((tag) => tag.trim() !== "");
      setTags(TagsArray);
      setFormattedTags(props.dataObj.tags);
      const keywordsArray = props.dataObj.keywordNames
        .split(",")
        .filter((keyword) => keyword.trim() !== "");
      setKeyword(keywordsArray);
      setFormattedKeyword(props.dataObj.keywordNames);
      setLeftHeader(props.dataObj.questionBankSet.columns[0].columnHeader);
      setRightHeader(props.dataObj.questionBankSet.columns[1].columnHeader);
      const leftColumn =
        props.dataObj?.questionBankSet?.columns[0]?.columnRows.map((el) => ({
          leftHeaderId: el.rowId,
          leftHeaderText: el.rowName,
        }));
      const rightColumn =
        props.dataObj?.questionBankSet?.columns[1]?.columnRows.map((el) => ({
          rightHeaderId: el.rowId,
          rightHeaderText: el.rowName,
        }));
      const combinedRows = leftColumn.map((leftRow, index) => ({
        ...leftRow,
        ...rightColumn[index], // Assuming left and right columns have the same length
      }));
      setRows(combinedRows);
      setExplanation(props.dataObj?.questionBankSet?.explanations);
      const responseChoices = props.dataObj.questionBankSet.responseChoice.map(
        (choice) => {
          return {
            answerOptionId: choice.responseId, // Assuming you want to assign an ID to each response option
            answerOptionText: choice.responseText,
          };
        }
      );
      setAnsOptionRows(responseChoices);
      setCorrectAnswer(props.dataObj?.questionBankSet?.correctResponse);
    } else {
      setQuestionTypeId(4);
      setQuestionTypeName("MC Matching Type");
      setQuestionBody("");
      setExamType("");
      setExplanation("");
      setTopicId(0);
      setTopicName("");
      setKeyword([]);
      setGradeId(0);
      setGradeName("");
      setDifficultyId(0);
      setDifficultyName("");
      setLanguageName("");
      setCountryName("");
      setTags([]);
      setCorrectAnswer("");
      setLeftHeader("");
      setRightHeader("");
    }

    // if (open && props.dataObj && props.dataObj.autoId) {
    //   setTemplateTitle(props.dataObj.templateTitle);
    //   setTreeviewTemplateId(props.dataObj.treeviewTemplateId);
    //   setTreeviewTemplateTitle(props.dataObj.treeviewTemplateTitle);
    //   setSelftestOptionsObjectiveId(props.dataObj.selftestOptionsObjectiveId);
    //   setSelftestOptionsObjectiveTitle(
    //     props.dataObj.selftestOptionsObjectiveTitle
    //   );
    //   setSelftestOptionsSubjectiveId(props.dataObj.selftestOptionsSubjectiveId);
    //   setSelftestOptionsSubjectiveTitle(
    //     props.dataObj.selftestOptionsSubjectiveTitle
    //   );
    //   setExamLimitId(props.dataObj.examLimitId);
    //   setExamLimitTitle(props.dataObj.examLimitTitle);
    //   setObjectiveQueTypeTempId(props.dataObj.objectiveQueTypeTempId);
    //   setObjectiveQueTypeTempTitle(props.dataObj.objectiveQueTypeTempTitle);
    //   setSubjectiveQueTypeTempId(props.dataObj.subjectiveQueTypeTempId);
    //   setSubjectiveQueTypeTempTitle(props.dataObj.subjectiveQueTypeTempTitle);
    //   setMocktestTemplateId(props.dataObj.mocktestTemplateId);
    //   setMocktestTemplateTitle(props.dataObj.mocktestTemplateTitle);
    //   setTopictestTemplateId(props.dataObj.topictestTemplateId);
    //   setTopictestTemplateTitle(props.dataObj.topictestTemplateTitle);
    // } else {
    //   setQuestionTypeId(7);

    //   setTemplateTitle("");
    //   setTreeviewTemplateId(0);
    //   setTreeviewTemplateTitle("");
    //   setSelftestOptionsObjectiveId(0);
    //   setSelftestOptionsObjectiveTitle("");
    //   setSelftestOptionsSubjectiveId(0);
    //   setSelftestOptionsSubjectiveTitle("");
    //   setExamLimitId(0);
    //   setExamLimitTitle("");
    //   setObjectiveQueTypeTempId(0);
    //   setObjectiveQueTypeTempTitle("");
    //   setSubjectiveQueTypeTempId(0);
    //   setSubjectiveQueTypeTempTitle("");
    //   setMocktestTemplateId(0);
    //   setMocktestTemplateTitle("");
    //   setTopictestTemplateId(0);
    //   setTopictestTemplateTitle("");
    // }
  }, [props.dataObj, open]);

  async function getApiData() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: userObj.loginId,
        token: userObj.token,
        device: "web",
      },
    };
    let endpoints1 =
      env.API_EXAM_SERVICE +
      "/topic-service/read/topics-templates?sortby=templateName&maxRows=50000";
    let endpoints2 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints3 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints4 =
      env.API_EXAM_SERVICE +
      "/exams/read/exam-limits-templates?sortby=templateTitle&maxRows=50000";
    let endpoints5 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-objective?sortby=templateTitle&maxRows=50000";
    let endpoints6 =
      env.API_EXAM_SERVICE +
      "/exams/read/selftest-options-subjective?sortby=templateTitle&maxRows=50000";
    let endpoints7 =
      env.API_EXAM_SERVICE +
      "/exams/read/mocktest-templates?sortby=templateTitle&maxRows=50000";
    let endpoints8 =
      env.API_EXAM_SERVICE +
      "/exams/read/topictest-templates?sortby=templateTitle&maxRows=50000";

    const axiosrequest1 = axios.get(endpoints1, axiosHeader);
    const axiosrequest2 = axios.get(endpoints2, axiosHeader);
    const axiosrequest3 = axios.get(endpoints3, axiosHeader);
    const axiosrequest4 = axios.get(endpoints4, axiosHeader);
    const axiosrequest5 = axios.get(endpoints5, axiosHeader);
    const axiosrequest6 = axios.get(endpoints6, axiosHeader);
    const axiosrequest7 = axios.get(endpoints7, axiosHeader);
    const axiosrequest8 = axios.get(endpoints8, axiosHeader);

    await axios
      .all([
        axiosrequest1,
        axiosrequest2,
        axiosrequest3,
        axiosrequest4,
        axiosrequest5,
        axiosrequest6,
        axiosrequest7,
        axiosrequest8,
      ])
      .then(
        axios.spread(function (res1, res2, res3, res4, res5, res6, res7, res8) {
          setTreeviewTemplateList(res1.data.list);
          setSelftestOptionsObjectiveList(res2.data.list);
          setSelftestOptionsSubjectiveList(res3.data.list);
          setExamLimitList(res4.data.list);
          setObjectiveQueTypeTempList(res5.data.list);
          setSubjectiveQueTypeTempList(res6.data.list);
          setMocktestTemplateList(res7.data.list);
          setTopictestTemplateList(res8.data.list);
        })
      );
  }

  const getData = async () => {
    try {
      let endpoint1 = env.API_KEY + "/topics-list";
      let endpoint2 = env.API_KEY + "/languages-list";
      let endpoint3 = env.API_KEY + "/country-list";
      let endpoint4 = env.API_KEY + "/difficulty-list";
      let endpoint5 = env.API_KEY + "/grades-list";

      const axiosrequest1 = axios.get(endpoint1);
      const axiosrequest2 = axios.get(endpoint2);
      const axiosrequest3 = axios.get(endpoint3);
      const axiosrequest4 = axios.get(endpoint4);
      const axiosrequest5 = axios.get(endpoint5);

      let [response1, response2, response3, response4, response5] =
        await axios.all([
          axiosrequest1,
          axiosrequest2,
          axiosrequest3,
          axiosrequest4,
          axiosrequest5,
        ]);
      setTopicList(response1?.data?.obj);
      setLanguageList(response2?.data?.obj);
      setCountryList(response3?.data?.obj);
      setDifficultyList(response4?.data?.obj);
      setGradeList(response5?.data?.obj);
    } catch (error) {
      console.log("error");
    }
  };

  const columns = [
    {
      columnHeader: leftHeader,
      columnRows: leftHeader
        ? rows.map((row, i) => ({
            rowId: row?.leftHeaderId,
            rowName: row?.leftHeaderText,
          }))
        : [],
    },
    {
      columnHeader: rightHeader,
      columnRows: rightHeader
        ? rows.map((row, i) => ({
            rowId: row?.rightHeaderId,
            rowName: row?.rightHeaderText,
          }))
        : [],
    },
  ];

  let questionJson = {
    questionType: questionTypeName,
    commonDataDescription: null,
    questionBody: questionBody,
    columns: columns,
    responseChoiceShuffle: "yes",
    responseChoice: ansOptionRows?.map((el) => {
      let obj = {};
      obj.responseId = el.answerOptionId;
      obj.responseText = el.answerOptionText;
      return obj;
    }),
    correctResponse: correctAnswer,
    explanations: explanation,
  };

  function handleSave() {
    if (!questionBody) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter question");
      return false;
    } else if (!leftHeader) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter left Header");
      return false;
    } else if (!rightHeader) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter right Header");
      return false;
    } else if (!topicName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Topic");
      return false;
    } else if (!gradeName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Grade Name");
      return false;
    } else if (!examType) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Exam Type");
      return false;
    } else if (!languageName) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select language");
      return false;
    }

    if (
      questionBody &&
      questionBody.length > 1 &&
      leftHeader &&
      rightHeader &&
      topicName &&
      gradeName &&
      examType &&
      languageName
    ) {
      setSaveLoading(true);

      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          // loginId: userObj.loginId,
          // token: userObj.token,
          // device: "web",
        },
      };
      const data = new FormData();
      if (props.dataObj && props.dataObj.autoId) {
        data.append("id", props.dataObj.autoId);
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", "MC Matching Type");
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      } else {
        data.append("questionTypeId", questionTypeId);
        data.append("questionJson", JSON.stringify(questionJson));
        data.append("questionType", "MC Matching Type");
        data.append("topicId", topicId);
        data.append("topicName", topicName);
        data.append("keywordNames", formattedKeyword);
        data.append("gradeId", gradeId);
        data.append("gradeName", gradeName);
        data.append("difficultyId", difficultyId);
        data.append("difficultyName", difficultyName);
        data.append("examType", examType);
        data.append("language", languageName);
        data.append("country", countryName);
        data.append("tags", formattedTags);
      }

      // private String commonDataDescription;
      // private String questionBody;
      // private List<BeanColumns> columns;
      // private List<BeanResponseChoice> answerOption;
      // private Boolean answerOptionShuffle;
      // private String correctAnswer;
      // private String explanation;

      //let questionJson = {'commonDataDescription':'','questionBody':questionBody, 'columns':rows, 'answerOption':rows, 'answerOptionShuffle':'', 'correctAnswer':correctAnswer, 'explanation':explanation};

      // data.append("answerOption", JSON.stringify(rows));
      // data.append("correctAnswer", correctAnswer);
      // data.append("explanation", explanation);

      // if (shuffle) {
      //   data.append("shuffle", 1);
      // } else {
      //   data.append("shuffle", 0);
      // }

      let apiURL = "/admin-questionbanks-create";
      let myMessage = "Question has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/admin-questionbanks-update";
        myMessage = "Question has been updated.";
      }

      // return;

      axios
        .post(env.API_KEY + apiURL, data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            props.updatedList(response.data.list);
            window.location.reload();
            return false;
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  function saveData() {
    if (!templateTitle) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter exam title");
      return false;
    }

    if (templateTitle && templateTitle.length > 1) {
      setSaveLoading(true);

      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          loginId: userObj.loginId,
          token: userObj.token,
          device: "web",
        },
      };
      const data = new FormData();
      if (props.dataObj && props.dataObj.autoId) {
        data.append("id", props.dataObj.autoId);
      }
      data.append("templateTitle", templateTitle);
      data.append("treeviewTemplateId", treeviewTemplateId);
      data.append("treeviewTemplateTitle", treeviewTemplateTitle);
      data.append("selftestOptionsObjectiveId", selftestOptionsObjectiveId);
      data.append(
        "selftestOptionsObjectiveTitle",
        selftestOptionsObjectiveTitle
      );
      data.append("selftestOptionsSubjectiveId", selftestOptionsSubjectiveId);
      data.append(
        "selftestOptionsSubjectiveTitle",
        selftestOptionsSubjectiveTitle
      );
      data.append("examLimitId", examLimitId);
      data.append("examLimitTitle", examLimitTitle);
      data.append("objectiveQueTypeTempId", objectiveQueTypeTempId);
      data.append("objectiveQueTypeTempTitle", objectiveQueTypeTempTitle);
      data.append("subjectiveQueTypeTempId", subjectiveQueTypeTempId);
      data.append("subjectiveQueTypeTempTitle", subjectiveQueTypeTempTitle);
      data.append("mocktestTemplateId", mocktestTemplateId);
      data.append("mocktestTemplateTitle", mocktestTemplateTitle);
      data.append("topictestTemplateId", topictestTemplateId);
      data.append("topictestTemplateTitle", topictestTemplateTitle);

      let apiURL = "/exams/create/exam-templates";
      let myMessage = "Template name has been created.";
      if (props.dataObj != null && props.dataObj.autoId) {
        apiURL = "/exams/update/exam-templates";
        myMessage = "Template name has been updated.";
      }

      axios
        .post(env.API_EXAM_SERVICE + apiURL, data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage(myMessage);
            props.updatedList(response.data.list);
            return false;
          } else if (response.data.responseTxt === "alreadyexistserror") {
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage(
              "This template name was created earlier. Enter another template name"
            );
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This template could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  const addTableAnsOptionRows = () => {
    const rowsInput = {
      answerOptionId: "",
      answerOptionText: "",
    };
    setAnsOptionRows([...ansOptionRows, rowsInput]);
  };

  const handleAnswerOption = (i, e, isLeft) => {
    const { value } = e?.target;
    setRows((prev) => {
      const updatedState = [...prev];
      updatedState[i] = {
        ...updatedState[i],
        [isLeft ? "leftHeaderId" : "rightHeaderId"]: isLeft
          ? alphaArr[i]
          : alphaNumArr[i],
        [isLeft ? "leftHeaderText" : "rightHeaderText"]: value,
      };
      return updatedState;
    });
  };

  function handleTableAnswerOption(i, event) {
    const { value } = event.target;
    setAnsOptionRows((prev) => {
      const updateState = [...prev];
      updateState[i] = {
        ...updateState[i],
        answerOptionId: alphaArr[i],
        answerOptionText: value,
      };
      return updateState;
    });
  }

  const addTableRows = () => {
    const rowsInput = {
      leftHeaderId: "",
      leftHeaderText: "",
      rightHeaderId: "",
      rightHeaderText: "",
    };
    setRows([...rows, rowsInput]);
  };

  console.log(rows, "rows");
  console.log(ansOptionRows, "ansOptionRows");

  function createOption(opt) {
    const rowsInput = {
      leftHeaderId: "",
      leftHeaderText: "",
      rightHeaderId: "",
      rightHeaderText: "",
      answerOptionId: "",
      answerOptionText: "",
    };
    let optArr = [];
    if (7 === opt) {
      for (let i = 0; i < 4; i++) {
        optArr.push(rowsInput);
      }
    }
    setRows(optArr);
    setAnsOptionRows(optArr);
  }

  function handleQuestionType(val) {
    setQuestionTypeId(val);
    createOption(val);
  }

  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  console.log(personName, "personName");

  const handleTopicChange = (selectedTopic) => {
    if (selectedTopic === null) {
      setTopicId(0);
      setTopicName("");
    }
    setTopicId(selectedTopic?.topicId || 0);
    setTopicName(selectedTopic?.topicName || "");
  };

  const handleGrade = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    setGradeId(valArr[0]);
    setGradeName(valArr[1]);
  };

  const handleDifficulty = (event) => {
    let val = event.target.value;
    let valArr = val.split("#");
    console.log(valArr);
    setDifficultyId(valArr[0]);
    setDifficultyName(valArr[1]);
  };

  const handleLanguageChange = (event) => {
    setLanguageName(event.target.value);
  };

  const handleCountryChange = (event) => {
    setCountryName(event.target.value);
  };

  const handleExamTypeChange = (event) => {
    setExamType(event.target.value);
  };

  const handleKeywordChange = (event, selectedTags) => {
    setKeyword(selectedTags);
    setFormattedKeyword(selectedTags.join(","));
  };

  const handleTagChange = (event, selectedTags) => {
    setTags(selectedTags);
    setFormattedTags(selectedTags.join(","));
  };

  return (
    <>
      <Dialog
        fullWidth
        disableEnforceFocus
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <DialogContent>
          <Box style={{ display: "flex" }}>
            <Grid item md={6} xs={6} className="test-instructions">
              <div className="btmbdrgry">
                <h3>
                  {props.dataObj != null ? <>Edit</> : <>New</>} MCMT Question
                </h3>
              </div>

              <Box mt={1}>
                <TextField
                  label="Question Body"
                  onChange={(event) => setQuestionBody(event.target.value)}
                  value={questionBody}
                  sx={{ fontSize: 10 }}
                  rows={3}
                  multiline
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </Box>

              <Box mt={1}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      label="Left Header"
                      onChange={(event) => setLeftHeader(event.target.value)}
                      value={leftHeader}
                      sx={{ fontSize: 10 }}
                      size="small"
                      variant="outlined"
                      fullWidth
                    />

                    {rows && rows.length > 0
                      ? rows.map((row, i) => (
                          <TextField
                            label="Match Option"
                            onChange={(event) =>
                              handleAnswerOption(i, event, true)
                            }
                            value={row?.leftHeaderText}
                            sx={{ fontSize: 10, marginTop: 1 }}
                            size="small"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div>{alphaArr[i]}</div>
                                </InputAdornment>
                              ),
                            }}
                          />
                        ))
                      : null}
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Right Header"
                      onChange={(event) => setRightHeader(event.target.value)}
                      value={rightHeader}
                      sx={{ fontSize: 10 }}
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                    {rows && rows.length > 0
                      ? rows.map((row, i) => (
                          <TextField
                            label="Match Option"
                            onChange={(event) =>
                              handleAnswerOption(i, event, false)
                            }
                            value={row?.rightHeaderText}
                            sx={{ fontSize: 10, marginTop: 1 }}
                            size="small"
                            variant="outlined"
                            fullWidth
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div>{alphaNumArr[i]}</div>
                                </InputAdornment>
                              ),
                            }}
                          />
                        ))
                      : null}
                  </Grid>
                </Grid>
              </Box>

              {rows && rows.length < 11 ? (
                <Box mt={1}>
                  <Button
                    onClick={() => {
                      addTableRows();
                    }}
                    style={{ textTransform: "none" }}
                    size="small"
                    variant="outlined"
                  >
                    Add Match Option
                  </Button>
                </Box>
              ) : null}

              <Box mt={1}>
                {ansOptionRows && ansOptionRows.length > 0
                  ? ansOptionRows.map((row, i) => (
                      <TextField
                        label="Answer Option"
                        onChange={(event) => handleTableAnswerOption(i, event)}
                        value={row?.answerOptionText}
                        sx={{ fontSize: 10, marginTop: 1 }}
                        size="small"
                        variant="outlined"
                        fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div>{alphaArr[i]}</div>
                            </InputAdornment>
                          ),
                        }}
                      />
                    ))
                  : null}
              </Box>
              {ansOptionRows && ansOptionRows.length < 26 ? (
                <Box mt={1}>
                  <Button
                    onClick={() => {
                      addTableAnsOptionRows();
                    }}
                    style={{ textTransform: "none" }}
                    size="small"
                    variant="outlined"
                  >
                    Add Answer Option
                  </Button>
                </Box>
              ) : null}

              <Box mt={1}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">
                    Correct Answer
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={correctAnswer}
                    label="Correct Answer"
                    onChange={(event) => setCorrectAnswer(event.target.value)}
                  >
                    {ansOptionRows && ansOptionRows.length > 0
                      ? ansOptionRows.map((row, i) => (
                          <MenuItem value={alphaArr[i]}>{alphaArr[i]}</MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>

                <TextField
                  label="Explanation"
                  onChange={(event) => setExplanation(event.target.value)}
                  value={explanation}
                  sx={{ fontSize: 10, marginTop: 1 }}
                  rows={3}
                  multiline
                  size="small"
                  variant="outlined"
                  fullWidth
                />
              </Box>
              <Box mt={1.5}>
                <TopicName
                  topicList={topicList}
                  handleTopicChange={handleTopicChange}
                  topicName={topicName}
                  topicId={topicId}
                />
              </Box>
              <Box mt={1.5}>
                <KeywordName
                  handleKeywordChange={handleKeywordChange}
                  keyword={keyword}
                />
              </Box>
              <Box mt={1.5}>
                <GradeName
                  gradeName={gradeName}
                  handleGrade={handleGrade}
                  gradeList={gradeList}
                  gradeId={gradeId}
                />
              </Box>
              <Box mt={1.5}>
                <DifficultyName
                  difficultyName={difficultyName}
                  handleDifficulty={handleDifficulty}
                  difficultyList={difficultyList}
                  difficultyId={difficultyId}
                />
              </Box>
              <Box mt={1.5}>
                <ExamType
                  examType={examType}
                  handleExamTypeChange={handleExamTypeChange}
                />
              </Box>
              <Box mt={1.5}>
                <Language
                  languageName={languageName}
                  handleLanguageChange={handleLanguageChange}
                  languageList={languageList}
                  languageId={languageId}
                />
              </Box>
              <Box mt={1.5}>
                <Country
                  countryName={countryName}
                  handleCountryChange={handleCountryChange}
                  countryList={countryList}
                  countryId={countryId}
                />
              </Box>
              <Box mt={1.5}>
                <Tags handleTagChange={handleTagChange} tag={tags} />
              </Box>

              <Box mt={2}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  style={{ marginRight: 12 }}
                  size="small"
                  variant="outlined"
                >
                  Cancel
                </Button>
                {saveLoading ? (
                  <LoadingButton
                    loading={saveLoading}
                    style={{
                      backgroundColor: "#008000",
                      color: "#FFF",
                      marginRight: 10,
                    }}
                    size="small"
                    variant="contained"
                  >
                    Save
                  </LoadingButton>
                ) : (
                  <Button
                    onClick={() => {
                      // saveData();
                      handleSave();
                    }}
                    style={{
                      backgroundColor: "#008000",
                      color: "#FFF",
                      marginRight: 10,
                    }}
                    size="small"
                    variant="contained"
                  >
                    Save
                  </Button>
                )}
              </Box>
            </Grid>
            <Grid item md={6} xs={6} spacing={1}>
              <div>
                <div className="btmbdrgry">
                  <h2 style={{ marginLeft: "20px" }}>Preview</h2>
                </div>
                <Box sx={{ marginTop: "20px", marginLeft: "20px" }}>
                  <h4>{questionBody ? "Q." + " " + questionBody : ""}</h4>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <Grid item md={6} xs={6} spacing={1}>
                    <h4 style={{ marginLeft: "20px" }}>{leftHeader}</h4>
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: 0,
                        marginLeft: "10px",
                      }}
                    >
                      {rows?.map((el, i) => (
                        <li key={i}>
                          {el.leftHeaderText && (
                            <>
                              <Typography
                                component="span"
                                style={{ marginRight: "5px" }}
                              >
                                {alphaArr[i] + " . "}
                              </Typography>
                            </>
                          )}
                          {el.leftHeaderText}
                        </li>
                      ))}
                    </ul>
                  </Grid>
                  <Grid item md={6} xs={6} spacing={1}>
                    <h4>{rightHeader}</h4>
                    <ul style={{ listStyleType: "none", padding: 0 }}>
                      {rows?.map((el, i) => (
                        <li key={i}>
                          {el.rightHeaderText && (
                            <>
                              <Typography
                                component="span"
                                style={{ marginRight: "5px" }}
                              >
                                {alphaNumArr[i] + " . "}
                              </Typography>
                            </>
                          )}
                          {el.rightHeaderText}
                        </li>
                      ))}
                    </ul>
                  </Grid>
                </Box>
                <Box sx={{ marginLeft: "20px" }}>
                  <ul style={{ listStyleType: "none", padding: 0 }}>
                    {ansOptionRows?.map((el, i) => (
                      <li key={i}>
                        {el.answerOptionText && (
                          <>
                            <Radio
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 26,
                                  padding: 0,
                                },
                              }}
                            />
                            <Typography
                              component="span"
                              style={{ marginRight: "5px" }}
                            >
                              {alphaArr[i] + " . "}
                            </Typography>
                          </>
                        )}
                        {el.answerOptionText}
                      </li>
                    ))}
                  </ul>
                  {correctAnswer && (
                    <Typography component="span">
                      <span>
                        <strong>Correct Answer :</strong>
                      </span>{" "}
                      {correctAnswer}
                    </Typography>
                  )}
                  <br />
                  {explanation && (
                    <Typography component="span">
                      <span>
                        <strong>Explanation :</strong>
                      </span>{" "}
                      {explanation}
                    </Typography>
                  )}
                </Box>
              </div>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={hideAlert}
            variant="filled"
            severity={severityAlert}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
});

export default CustomizedDialogs;
